import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appOfferModal]',
  standalone: true
})
export class OfferModalDirective {
  constructor(public readonly viewContainerRef: ViewContainerRef) {}
}
